import { generateUUID } from '@wix/form-schema';
import { Image as ImageIcon } from '@wix/wix-ui-icons-common/lazy';
import { BoxSelection, Image, ImageResizeOptions, Text, Checkbox } from '@wix/wix-ui-tpa/cssVars';
import React from 'react';
import { useConfig } from '../../contexts/config-context';
import { ImageAlignment, ImageFit } from '../../types/image';
import { classes, st } from './media-box-selection.st.css';
export const MediaBoxSelectionWUT = ({ className = '', dataHook = '', label = '', alignment = ImageAlignment.LEFT, fit = ImageFit.COVER, isMultipleAnswers, columns, options, value, onChange })=>{
    const { isMobile } = useConfig();
    const onSelectionChange = React.useCallback(({ id })=>{
        let innerValue = (value || []).slice(0);
        if (innerValue.includes(id)) {
            innerValue = innerValue.filter((item)=>item !== id);
        } else {
            if (isMultipleAnswers) {
                innerValue = [
                    ...innerValue,
                    id
                ];
            } else {
                innerValue = [
                    id
                ];
            }
        }
        onChange?.(innerValue);
    }, [
        value,
        isMultipleAnswers,
        onChange
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        className: st(classes.root, {
            mobile: isMobile,
            alignment,
            fit,
            columns
        }, className),
        "data-hook": dataHook
    }, /*#__PURE__*/ React.createElement("div", {
        className: classes.content
    }, /*#__PURE__*/ React.createElement(BoxSelection, {
        name: `media-box-selection-${generateUUID()}`,
        label: label,
        onChange: onSelectionChange
    }, options.map((option)=>{
        const image = option.media?.image;
        const aspectRatio = image ? image.width / image.height : 1;
        return /*#__PURE__*/ React.createElement(BoxSelection.Option, {
            id: option.label,
            className: classes.option,
            checked: (value || []).includes(option.label),
            disabled: false
        }, /*#__PURE__*/ React.createElement("div", {
            className: classes.optionMediaContent
        }, /*#__PURE__*/ React.createElement("div", {
            className: classes.imgWrapper,
            key: `img-wrapper-${fit}-${columns}`
        }, image ? /*#__PURE__*/ React.createElement(Image, {
            className: classes.img,
            src: option.media?.image?.id,
            alt: option.media?.altText || option?.altText || image?.altText || '',
            aspectRatio: aspectRatio,
            sourceWidth: image?.width || 100,
            sourceHeight: image?.height || 100,
            stretchImage: false,
            resize: fit === ImageFit.COVER ? ImageResizeOptions.cover : ImageResizeOptions.contain
        }) : /*#__PURE__*/ React.createElement("div", {
            className: classes.blankImgWrapper
        }, /*#__PURE__*/ React.createElement(ImageIcon, {
            className: classes.blankImg
        }))), option.label && !option.isLabelHidden ? /*#__PURE__*/ React.createElement(Text, {
            tagName: "p",
            className: classes.optionLabel
        }, option.label) : null));
    }))));
};
MediaBoxSelectionWUT.includeCheckboxInBundle = Checkbox;

//# sourceMappingURL=media-box-selection-wut.js.map